import script from "./Corp.vue?vue&type=script&setup=true&lang=js"
export * from "./Corp.vue?vue&type=script&setup=true&lang=js"

import "./Corp.vue?vue&type=style&index=0&id=43f817e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43f817e2"]])

export default __exports__